/*

 *   File : rpd.js

 *   Description : Reverse penny drop entry page (admin emailed link — KYC onboarding)

 *   Admin flow mirrors IPV: stay on /rpd?token=, poll callback via OrderAPIService

 */



import { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import Cookies from 'js-cookie';



import Icon from '../../Component/Icon/icon';

import { GradientButton } from '../../Component/CTA';

import { CustomLoader } from '../../Component/Other';



import OrderAPIService from '../../Service/order-api';
import {
    clearAdminRpdToken,
    clearRpdPollPending,
    initiateRpd,
    openDigioRpd,
    pollRpdUntilComplete,
    setAdminRpdToken,
    setRpdPollPending,
} from '../../Helper/rpd';



function LinkBankTypeCard(props) {

    const { title, desc, recommended } = props;



    return (

        <div className={props.className}>

            <Icon icon={props.icon}

                size={22}

                className="position-absolute cursor-pointer right-10px" />



            <div className="row">

                <div className="col-12 d-flex">

                    <h4 className="color-black e-poppins-semi-bold e-font-16 margin-block-end-0 line-height-normal me-2">

                        {title}

                    </h4>

                    <img src={props.image}

                        alt="UPI"

                        draggable={false}

                        className="me-2" />

                    {

                        recommended === true && (

                            <span className="e-bank-recommended-badge border-radius-8px bg-bubble-light e-poppins-regular e-font-10 h-max-content padding-2px-tb padding-4px-lr">

                                Recommended

                            </span>

                        )

                    }

                </div>

                <div className="col-12 text-start">

                    <p className="e-inter-regular e-font-14 color-outer-space margin-block-end-0 mt-2">{desc}</p>

                </div>

            </div>

        </div>

    );

}



export default function InitiateRpd() {

    const [apiLoader, setApiLoader] = useState(false);

    const [pageLoader, setPageLoader] = useState(true);

    const [polling, setPolling] = useState(false);

    const [adminToken, setAdminToken] = useState(null);



    function _redirectUser() {
        clearRpdPollPending();
        clearAdminRpdToken();

        const loginStatus = Cookies.get('refreshToken');

        if (loginStatus) {

            window.location.href = '/';

        } else {

            window.location.href = process.env.REACT_APP_LANDING_PAGE_URL;

        }

    }



    useEffect(() => {

        const params = new URLSearchParams(window.location.search);

        const token = params.get('token');

        const digioReturn = params.get('digio_return') === '1';



        if (token) {

            setAdminToken(token);
            setAdminRpdToken(token);

        }



        if (digioReturn === true && token) {

            setRpdPollPending();
            setAdminRpdToken(token);
            setPolling(true);

            pollRpdUntilComplete({

                kycFlow: true,

                useOrderApi: true,

                onSuccess: (response) => {
                    const message = (response?.message || '').toLowerCase();
                    const isAlreadyExists = message.includes('already exists');

                    toast.dismiss();
                    toast.success(
                        isAlreadyExists
                            ? 'Bank account already verified'
                            : 'Bank account verified successfully'
                    );
                    setPolling(false);
                    _redirectUser();
                },

                onFailure: (response) => {
                    clearRpdPollPending();

                    setPolling(false);

                    toast.dismiss();

                    toast.error(response.message || 'Bank verification failed', { type: 'error' });

                },

            });

        }



        setPageLoader(false);

    }, []);



    const _handleProceed = () => {

        setApiLoader(true);

        const initiateRequest = adminToken

            ? OrderAPIService(false, 'kyc/initiate-rpd', null, false, true)

            : initiateRpd(true);



        initiateRequest.then((response) => {

            if (response.status_code === 200) {

                try {

                    openDigioRpd(response.data, {

                        kycFlow: true,

                        adminToken: adminToken || undefined,

                    });

                } catch (error) {

                    toast.dismiss();

                    toast.error('Unable to open Digio verification. Please try again.', { type: 'error' });

                }

            } else {

                toast.dismiss();

                toast.error(response.message, { type: 'error' });

            }

            setApiLoader(false);

        }).catch(() => {

            toast.dismiss();

            toast.error('Unable to start bank verification. Please try again.', { type: 'error' });

            setApiLoader(false);

        });

    };



    if (pageLoader === true || polling === true) {

        return (

            <div className="w-100 h-100vh d-flex justify-content-center align-items-center">

                <CustomLoader />

            </div>

        );

    }



    return (

        <div className="e-page-container margin-72px-bottom">

            <div className="container padding-64px-lr-md py-5">

                <p className="color-black e-poppins e-poppins-bold e-font-24-sm-18 mb-sm-2 mb-0">

                    Add your bank account

                </p>



                <div className="row mt-3">

                    <div className="col-lg-7 col-md-7 col-12">

                        <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-0">

                            Verify and register your account with mt wealth. As per regulatory requirements you can invest through a registered bank account only.

                        </p>

                    </div>



                    <div className="col-lg-7 col-md-7 col-12 mt-sm-4 mt-2">

                        <LinkBankTypeCard

                            title="Verify with"

                            desc="Complete a ₹1 UPI reverse penny drop to verify your bank account. The amount will be refunded after verification is complete."

                            recommended={true}

                            className="border-pearl-aqua bg-frosty-cyan p-3 border-all border-radius-16px position-relative"

                            icon="radio-selected"

                            image={require('../../Assets/Images/profile/upi_logo.svg').default}

                        />

                    </div>



                    <div className="col-lg-7 col-md-7 col-12 mt-3">

                        <p className="e-poppins-regular e-font-14 color-outer-space margin-block-end-0">

                            *Use your primary account which matches with the name on your PAN card

                        </p>

                    </div>

                </div>



                <GradientButton label="Continue securely with UPI"

                    loading={apiLoader}

                    className="px-4 padding-12px-tb margin-40px-top mob-w-100 mb-sm-0 mb-3"

                    handleClick={_handleProceed} />

            </div>

        </div>

    );

}


